export default __webpack_public_path__ + "static/media/SoundOff-Button.d350f3c4.svg";